import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { bemGenerator } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import CloseIcon from 'mdi-react/CloseIcon';

import './index.scss';

const APP_ROOT_ID = 'root';
const MODAL_ROOT_ID = 'root-modal';

const styles = bemGenerator('pj-modal', [
  'content',
  'viewport',
  'overlay',
  'close',
]);

const getModalRoot = () => document.getElementById(MODAL_ROOT_ID);

const Modal = props => {
  React.useEffect(() => {
    ReactModal.setAppElement(`#${APP_ROOT_ID}`);
  }, []);

  const { id, current, isOpen, verticalScroll, width, children } = props;
  return (
    <ReactModal
      {...props}
      isOpen={isOpen || (!!current && current === id)}
      parentSelector={getModalRoot}
      className={{
        base: styles.content.withModifier({ verticalScroll }),
        afterOpen: '',
        beforeClose: '',
      }}
      overlayClassName={{
        base: styles.overlay.withModifier({ verticalScroll }),
        afterOpen: '',
        beforeClose: '',
      }}
      style={{
        content: { width },
      }}
      data-test="ModalDialog"
    >
      {verticalScroll ? (
        <div className={styles.viewport}>{children}</div>
      ) : (
        children
      )}
      {props.shouldShowCloseIcon && (
        <Button
          variant="icon"
          className={styles.close}
          onClick={() => props.onRequestClose()}
          tabIndex={0}
          icon={<CloseIcon />}
          data-test="ModalDialogCloseButton"
        />
      )}
    </ReactModal>
  );
};

const { node, func, bool, number, string, oneOfType } = PropTypes;
Modal.propTypes = {
  current: string,
  id: string,
  isOpen: bool,
  children: node,
  onRequestClose: func,
  width: oneOfType([number, string]),
  shouldShowCloseIcon: bool,
  shouldCloseOnOverlayClick: bool,
  verticalScroll: bool,
};

Modal.defaultProps = {
  current: undefined,
  id: undefined,
  isOpen: false,
  children: null,
  onRequestClose: () => {},
  width: 'auto',
  shouldShowCloseIcon: true,
  shouldCloseOnOverlayClick: true,
  verticalScroll: false,
};

export default connect(state => ({ ...state.modal }))(Modal);
